"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Record = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const Record = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, props.value && (react_1.default.createElement(material_1.Box, { sx: {
            pt: 1,
            display: 'flex',
            justifyContent: 'space-between',
            '&:first-of-type': {
                paddingTop: 0,
            },
            '&:last-of-type': {
                pb: 2,
            },
        } },
        react_1.default.createElement(material_1.Typography, null, props.title),
        react_1.default.createElement(material_1.Box, { sx: { pl: 2, pr: 2, alignSelf: 'center' } },
            react_1.default.createElement(material_1.Typography, null, props.value))))));
};
exports.Record = Record;
